class BNTestimonialSlider {

    constructor(selector, options = {}) {

        this.slider = document.querySelector(selector);

        if (!this.slider) return;

        this.track =
            this.slider.querySelector(
                '.bn-testimonial-track'
            );

        if (!this.track) return;

        this.slides =
            [...this.track.children];

        if (!this.slides.length) return;

        this.options = {

            autoplay: true,

            autoplayTimeout: 5000,

            speed: 600,

            pauseOnHover: true,

            swipeThreshold: 50,

            responsive: {

                0: 1,

                768: 2,

                992: 3
            },

            ...options
        };

        this.current = 0;

        this.timer = null;

        this.startX = 0;

        this.isDragging = false;

        this.init();
    }

    getItemsPerView() {

        const width =
            window.innerWidth;

        let items = 1;

        Object.entries(
            this.options.responsive
        ).forEach(([bp, value]) => {

            if (width >= Number(bp)) {

                items = value;
            }
        });

        return items;
    }

    getPages() {

        return Math.max(
            1,
            this.slides.length -
            this.itemsPerView +
            1
        );
    }

    init() {

        this.itemsPerView =
            this.getItemsPerView();

        this.setupSlides();

        this.buildDots();

        this.update();

        this.bindEvents();

        if (
            this.options.autoplay &&
            this.getPages() > 1
        ) {

            this.play();
        }
    }

    setupSlides() {

        const gap =
            parseFloat(
                getComputedStyle(
                    this.track
                ).gap
            ) || 0;

        const sliderWidth =
            this.slider.clientWidth;

        const itemWidth =
            (
                sliderWidth -
                (
                    gap *
                    (
                        this.itemsPerView - 1
                    )
                )
            ) /
            this.itemsPerView;

        this.slides.forEach(slide => {

            slide.style.flex =
                `0 0 ${itemWidth}px`;

            slide.style.maxWidth =
                `${itemWidth}px`;
        });
    }

    buildDots() {

        const oldDots =
            this.slider.querySelector(
                '.bn-testimonial-dots'
            );

        if (oldDots) {

            oldDots.remove();
        }

        const pages =
            this.getPages();

        if (pages <= 1) {

            this.dots = [];

            return;
        }

        this.dotsWrap =
            document.createElement(
                'div'
            );

        this.dotsWrap.className =
            'bn-testimonial-dots';

        this.slider.appendChild(
            this.dotsWrap
        );

        this.dots = [];

        for (
            let i = 0;
            i < pages;
            i++
        ) {

            const dot =
                document.createElement(
                    'button'
                );

            dot.type = 'button';

            dot.className =
                'bn-testimonial-dot';

            dot.addEventListener(
                'click',
                () => {

                    this.current = i;

                    this.update();

                    if (
                        this.options.autoplay
                    ) {

                        this.play();
                    }
                }
            );

            this.dotsWrap.appendChild(
                dot
            );

            this.dots.push(dot);
        }
    }

    updateDots() {

        if (
            !this.dots ||
            !this.dots.length
        ) return;

        this.dots.forEach(dot =>
            dot.classList.remove(
                'bn-active'
            )
        );

        if (
            this.dots[this.current]
        ) {

            this.dots[
                this.current
            ].classList.add(
                'bn-active'
            );
        }
    }

    update() {

        this.itemsPerView =
            this.getItemsPerView();

        this.setupSlides();

        const gap =
            parseFloat(
                getComputedStyle(
                    this.track
                ).gap
            ) || 0;

        const item =
            this.slides[0];

        if (!item) return;

        const itemWidth =
            item.offsetWidth;

        const translate =
            this.current *
            (
                itemWidth + gap
            );

        this.track.style.transition =
            `transform ${this.options.speed}ms cubic-bezier(.22,.61,.36,1)`;

        this.track.style.transform =
            `translate3d(-${translate}px,0,0)`;

        this.updateDots();
    }

    next() {

        const max =
            this.getPages() - 1;

        this.current =
            this.current >= max
                ? 0
                : this.current + 1;

        this.update();
    }

    prev() {

        const max =
            this.getPages() - 1;

        this.current =
            this.current <= 0
                ? max
                : this.current - 1;

        this.update();
    }

    play() {

        this.stop();

        this.timer =
            setInterval(
                () => {

                    this.next();

                },
                this.options
                    .autoplayTimeout
            );
    }

    stop() {

        clearInterval(
            this.timer
        );
    }

    bindEvents() {

        window.addEventListener(
            'resize',
            () => {

                const old =
                    this.itemsPerView;

                this.itemsPerView =
                    this.getItemsPerView();

                if (
                    old !==
                    this.itemsPerView
                ) {

                    this.current = 0;

                    this.buildDots();
                }

                this.update();
            }
        );

        if (
            this.options.pauseOnHover
        ) {

            this.slider.addEventListener(
                'mouseenter',
                () => this.stop()
            );

            this.slider.addEventListener(
                'mouseleave',
                () => this.play()
            );
        }

        this.slider.addEventListener(
            'touchstart',
            e => {

                this.startX =
                    e.touches[0]
                        .clientX;
            }
        );

        this.slider.addEventListener(
            'touchend',
            e => {

                const endX =
                    e.changedTouches[0]
                        .clientX;

                const diff =
                    this.startX -
                    endX;

                if (diff > 50) {

                    this.next();
                }

                if (diff < -50) {

                    this.prev();
                }
            }
        );

        this.slider.addEventListener(
            'mousedown',
            e => {

                this.isDragging =
                    true;

                this.startX =
                    e.clientX;
            }
        );

        window.addEventListener(
            'mouseup',
            e => {

                if (
                    !this.isDragging
                ) return;

                this.isDragging =
                    false;

                const diff =
                    this.startX -
                    e.clientX;

                if (diff > 50) {

                    this.next();
                }

                if (diff < -50) {

                    this.prev();
                }
            }
        );
    }
}

document.addEventListener(
    'DOMContentLoaded',
    () => {

        new BNTestimonialSlider(
            '.bn-testimonial-slider',
            {

                autoplay: true,

                autoplayTimeout: 5000,

                speed: 600,

                pauseOnHover: true,

                responsive: {

                    0: 1,

                    768: 2,

                    992: 3
                }
            }
        );
    }
);